export default __webpack_public_path__ + "static/media/12.15d73313.svg";